import type { FlagT } from './types';

export function sortFlags(a: FlagT, b: FlagT) {
  return a.displayName.localeCompare(b.displayName);
}
